export const edit = () => (
  <path
    d="M20 10l-6-6M2 16v6h6L21 9a4.243 4.243 0 10-6-6L2 16z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
